import { connect } from 'react-redux'
import get from 'lodash/get';

const mapStateToProps = (state) => ({
  data: get(state, ["stepsState", "data"], []),
  openResultPage: get(state, ["stepsState", "openResultPage"], false),
});

const mapDispatchToProps = {}

export const withResultPage = Component => connect(mapStateToProps, mapDispatchToProps)(Component)